import React from 'react';
import { useTranslation } from 'react-i18next';
import type { AnswerOption as AnswerOptionType } from '../../types';

interface AnswerOptionProps {
  option: AnswerOptionType;
  isSelected: boolean;
  onSelect: (optionId: string) => void;
}

export default function AnswerOption({ option, isSelected, onSelect }: AnswerOptionProps) {
  const { i18n } = useTranslation();
  const isSpanish = i18n.language === 'es';

  const optionText = isSpanish && option.optionTextEs
    ? option.optionTextEs
    : option.optionText;

  return (
    <button
      onClick={() => onSelect(option.id)}
      className={`w-full text-left p-4 rounded-xl border-2 transition-all duration-200 ${
        isSelected
          ? 'border-primary-500 bg-primary-50 ring-2 ring-primary-200'
          : 'border-gray-200 bg-white hover:border-gray-300 hover:bg-gray-50'
      }`}
    >
      <div className="flex items-center gap-3">
        {/* Radio indicator */}
        <div
          className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-colors ${
            isSelected
              ? 'border-primary-500 bg-primary-500'
              : 'border-gray-300'
          }`}
        >
          {isSelected && (
            <div className="w-2 h-2 rounded-full bg-white" />
          )}
        </div>

        {/* Option text */}
        <span
          className={`font-medium ${
            isSelected ? 'text-primary-900' : 'text-gray-700'
          }`}
        >
          {optionText}
        </span>
      </div>
    </button>
  );
}
